export default __webpack_public_path__ + "static/media/ONE.ba412416.svg";